export default class ListaDocumentos {
    constructor() {
        this.sections = document.querySelectorAll('.component-lista_documentos');
        this.ready();
    }

    ready() {

        this.sections.forEach(section => {
            const selectCategory = section.querySelector('form #filesCategory')
            const selectYears = section.querySelector('form #filesYear')
            
            const allLinks = section.querySelectorAll('a')

        if (selectCategory) {
            const tiposExistentes = new Set();
            allLinks.forEach(link => {
                if (link.dataset.tipo) {
                    tiposExistentes.add(link.dataset.tipo);
                }
            });

            const options = selectCategory.querySelectorAll('option');
            let firstValidOption = null;

            options.forEach(option => {
                if (!tiposExistentes.has(option.value)) {
                    option.remove();
                } else if (!firstValidOption) {
                    firstValidOption = option;
                }
            });

            if (firstValidOption) {
                firstValidOption.selected = true;
            }

            const showCategory = () => {
                const category = selectCategory.value;
                allLinks.forEach(link => {
                    const categoryLink = link.dataset.tipo;
                    if (categoryLink === category) {
                        link.classList.remove('hidden');
                    } else {
                        link.classList.add('hidden');
                    }
                });
            };

            showCategory();

            selectCategory.addEventListener('change', showCategory);
        }

            if(selectYears) {

                allLinks.forEach(link => {
                    const yearItem = link.dataset.ano
                    if(yearItem == selectYears.value) {
                        link.classList.remove('hidden')
                    }
                })

                selectYears.addEventListener('change', () => {
                    const year = selectYears.value;
                    
                    allLinks.forEach(link => {
                        const yearItem = link.dataset.ano
                        if(yearItem == year) {
                            link.classList.remove('hidden')
                        } else {
                            link.classList.add('hidden')
                        }
                    })
    
                });
            }

        })

    }

}

if (document.querySelector('.component-lista_documentos')) {
    new ListaDocumentos();
}